module.exports = __webpack_public_path__ + "static/media/mysql.a3313877.png";